import React from "react";
import { Box, Chip, Container, Paper, Stack, Typography } from "@mui/material";
import WebOutlinedIcon from "@mui/icons-material/WebOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import RocketLaunchOutlinedIcon from "@mui/icons-material/RocketLaunchOutlined";

const steps = [
  {
    icon: WebOutlinedIcon,
    title: "Configurá",
    text: "Elegí tu tipo de negocio y partí de una estructura inicial.",
  },
  {
    icon: Inventory2OutlinedIcon,
    title: "Cargá",
    text: "Sumá identidad, productos, servicios o turnos que realmente usás.",
  },
  {
    icon: RocketLaunchOutlinedIcon,
    title: "Publicá",
    text: "Poné la web online y empezá a usar tu proyecto con clientes reales.",
  },
];

export default function StepsSection() {
  return (
    <Box
      id="como-funciona"
      component="section"
      aria-labelledby="como-funciona-title"
      sx={{ py: { xs: 5, sm: 7, md: 11 }, scrollMarginTop: 90 }}
    >
      <Container maxWidth="lg">
        <Box sx={{ maxWidth: 700, mx: "auto", textAlign: "center" }}>
          <Chip
            label="Cómo empezar"
            sx={{
              bgcolor: "rgba(243,90,58,.09)",
              color: "#C83E21",
              fontWeight: 900,
            }}
          />
          <Typography
            id="como-funciona-title"
            component="h2"
            sx={{
              mt: 2,
              color: "#19242F",
              fontWeight: 950,
              letterSpacing: "-.045em",
              lineHeight: 1.05,
              fontSize: { xs: "1.72rem", sm: "2.35rem", md: "3.2rem" },
            }}
          >
            De la idea a tu web, en tres pasos.
          </Typography>
          <Typography
            sx={{
              mt: { xs: 1, sm: 1.5 },
              color: "rgba(25,36,47,.64)",
              fontSize: { xs: ".88rem", md: "1.06rem" },
              lineHeight: { xs: 1.45, sm: 1.6 },
            }}
          >
            No necesitás resolver todo antes de salir online.
          </Typography>
        </Box>

        <Box
          sx={{
            mt: { xs: 2.5, sm: 3.5, md: 6 },
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "repeat(3, minmax(0, 1fr))" },
            gap: { xs: 1.5, sm: 2 },
          }}
        >
          {steps.map(({ icon: Icon, title, text }, index) => (
            <Paper
              key={title}
              elevation={0}
              sx={{
                p: { xs: 1.45, sm: 2.2, md: 2.8 },
                borderRadius: 4,
                border: "1px solid rgba(25,36,47,.09)",
                bgcolor: index === 0 ? "#FFF7F3" : "#fff",
                boxShadow: "0 14px 36px rgba(25,36,47,.055)",
              }}
            >
              <Stack
                direction={{ xs: "row", sm: "column" }}
                spacing={{ xs: 1.2, sm: 0 }}
                alignItems={{ xs: "flex-start", sm: "stretch" }}
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{ flexShrink: 0 }}
                >
                  <Box
                    sx={{
                      width: { xs: 38, sm: 48 },
                      height: { xs: 38, sm: 48 },
                      borderRadius: 3,
                      display: "grid",
                      placeItems: "center",
                      bgcolor: index === 0 ? "#F35A3A" : "rgba(25,36,47,.08)",
                      color: index === 0 ? "#fff" : "#19242F",
                    }}
                  >
                    <Icon />
                  </Box>
                  <Typography
                    sx={{
                      display: { xs: "none", sm: "block" },
                      color: "rgba(25,36,47,.25)",
                      fontWeight: 950,
                      fontSize: "1.35rem",
                    }}
                  >
                    0{index + 1}
                  </Typography>
                </Stack>

                <Box sx={{ minWidth: 0, mt: { sm: 2.2 } }}>
                  <Stack direction="row" spacing={1} alignItems="baseline">
                    <Typography
                      sx={{
                        display: { xs: "block", sm: "none" },
                        color: "rgba(25,36,47,.34)",
                        fontWeight: 950,
                        fontSize: ".78rem",
                      }}
                    >
                      0{index + 1}
                    </Typography>
                    <Typography
                      sx={{
                        color: "#19242F",
                        fontWeight: 900,
                        fontSize: { xs: ".98rem", md: "1.08rem" },
                        lineHeight: 1.2,
                      }}
                    >
                      {title}
                    </Typography>
                  </Stack>
                  <Typography
                    sx={{
                      mt: { xs: .45, sm: .8 },
                      color: "rgba(25,36,47,.64)",
                      fontSize: { xs: ".82rem", sm: ".91rem" },
                      lineHeight: { xs: 1.4, sm: 1.55 },
                    }}
                  >
                    {text}
                  </Typography>
                </Box>
              </Stack>
            </Paper>
          ))}
        </Box>

      </Container>
    </Box>
  );
}
